import React, { lazy, Suspense, useEffect, useState } from 'react';
import { Backdrop, CircularProgress } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { LicenseInfo } from '@mui/x-license';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { I18nextProvider } from 'react-i18next';
import i18n from '@/i18n';
import updateLocale from 'dayjs/plugin/updateLocale';
// import utc from 'dayjs/plugin/utc';
// import timezone from 'dayjs/plugin/timezone';
import { HashRouter } from 'react-router-dom';
import Main from '@/Main';
import Theme from '@/Theme';
import 'dayjs/locale/en';
import 'dayjs/locale/de';
import 'dayjs/locale/it';
import 'dayjs/locale/pl';
import 'dayjs/locale/nl';
import 'dayjs/locale/fr';
import 'dayjs/locale/da';
import { CookiesProvider } from 'react-cookie';
import SearchBarWidget from "@/widget/SearchBarWidget";
import {MsalAppProvider} from "@/auth/MsalAppProvider";

const DrawerSearchWidget = lazy(() => import('@/widget/DrawerSearchWidget'));
const HuBOL = lazy(() => import('@/HuBOL'));

dayjs.extend(updateLocale);
['it','en','de','pl','fr','nl','da'].forEach((locale) => {
  dayjs.extend(updateLocale);
  dayjs.updateLocale(locale, { weekStart: 1 });
});

declare global {
  interface Window {
    isBookingOnlinePage: boolean;
  }
}

LicenseInfo.setLicenseKey(
  'e0d9bb8070ce0054c9d9ecb6e82cb58fTz0wLEU9MzI0NzIxNDQwMDAwMDAsUz1wcmVtaXVtLExNPXBlcnBldHVhbCxLVj0y'
);

const LoadingFallback = (
  <Backdrop open style={{ zIndex: 99 }}>
    <CircularProgress color="inherit" />
  </Backdrop>
);

const isBookingOnline = window.isBookingOnlinePage || window.location.href.includes('booking-online');

function App() {
  return (
    <CookiesProvider>
      <MsalAppProvider>
        <I18nextProvider i18n={i18n}>
          <HashRouter>
            <Main>
              <Theme>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <Suspense fallback={LoadingFallback}>
                    {isBookingOnline ? <HuBOL /> : <SearchBarWidget />}
                  </Suspense>
                </LocalizationProvider>
              </Theme>
            </Main>
          </HashRouter>
        </I18nextProvider>
      </MsalAppProvider>
    </CookiesProvider>
  );
}

export default App;
